export default {
  welcomeDialog: {
    logoAlt: 'شعار الاتحاد الفرنسي للرجبي',
    welcome: {
      introduction: {
        firstParagraph: {
          welcome: 'مرحبًا بك في تطبيق',
          description: '، حليفك للتدرّب وتعظيم إمكاناتك، والمصمّم لجميع الرياضيين، سواء كانوا مبتدئين أو خبراء!'
        },
        secondParagraph: {
          noMoralizingSpeech: 'هنا، لا خطابات وعظية، بل',
          practicalAdvices: 'فقط نصائح عملية وملهمة، ضمن مسار ديناميكي وآمن',
          capableOfBoosting: '، قادرة على تعزيز',
          performance: 'أدائك',
          andYour: 'و',
          recovery: 'تعافيك',
          whileTakingCareOf: '، مع العناية',
          mentalHealth: 'بـصحتك النفسية',
          andYour2: 'و',
          wellBeing: 'رفاهيتك.'
        },
        thirdParagraph: {
          theIdea: 'الفكرة؟',
          toAssistYou: 'مرافقتك خطوة بخطوة حتى يكون لكل يوم دور في تقدمك.'
        }
      },
      description: {
        withThisApplication: 'مع هذا التطبيق،',
        youHaveEverything: 'لديك كل ما تحتاجه لمتابعة تقدمك، وفهم جسمك وعقلك، وتقديم أفضل ما لديك:',
        selfEvaluationForm: 'استبيانات بسيطة وسريعة وفعّالة لتقييم حالتك البدنية ذاتيًا بشكل يومي.',
        physicalAndCognitiveExercises: 'تمارين بدنية ومعرفية مثبتة علميًا لتقوية جسمك ودماغك، ومصممة لتعزيز تعافيك وتحسين أدائك.',
        balanceTests: 'اختبارات توازن مع تحليل بالفيديو لاكتشاف نقاط قوتك والجوانب التي تحتاج إلى تعزيز، وتوجيهك بدقة، وتدريب ثباتك وردود أفعالك.',
        breathingExercises: 'تمارين تنفس مصممة خصيصًا لتهدئة ذهنك، وتنظيم توترك، وتعزيز رفاهيتك.',
        tipsAndRoutines: 'نصائح وروتينات لتحسين جودة نومك وتحسين تعافيك.',
        nutritionRecommendation: 'توصيات غذائية لتوفير جميع العناصر الغذائية اللازمة لنشاطك.'
      },
      recap: {
        whatYouWillLike: 'ما ستحبه',
        aCustomSupport: 'مرافقة مصممة خصيصًا لك، ومعتمدة من خبراء، ترشدك خطوة بخطوة نحو تجربة أفضل، لتتطور وفق إيقاعك وبدون ضغط، وتتابع تقدمك يومًا بعد يوم، حتى تكون كل حصة مفيدة لك فعلًا.',
        keyToSuccess: 'مفتاح النجاح؟ الانتظام.',
        beRegular: 'من خلال التزامك كل يوم، وفق إيقاعك، تصبح صحتك بين يديك، وتعزز تعافيًا فعّالًا، وتحسّن أداءك، وتنمّي صحة نفسية قوية. إن ممارسة هذه التمارين بانتظام هي السر لتصبح أقوى، وأسرع، وأكثر تركيزًا.',
        readyToSurpassYourself: 'إذًا، هل أنت مستعد لتتجاوز حدودك؟'
      },
      conclusion: {
        withTheApplication: 'مع تطبيق {appName}',
        completeAndCustomProgram: '، تستفيد من برنامج كامل ومخصص.',
        changeYourEffortsIntoSuccess: 'حوّل جهودك إلى نجاح، لتكون واثقًا ومستعدًا لمواجهة كل التحديات!'
      }
    },
    startButton: 'ابدأ'
  },
  concussionHistory: {
    logoAlt: 'شعار الاتحاد الفرنسي للرجبي',
    title: 'تاريخ الارتجاجات',
    instructions: {
      description1: 'يسمح هذا الاستبيان بجمع معلومات حول تاريخك مع الارتجاجات الدماغية.',
      description2: 'ستساعد هذه المعلومات في تخصيص متابعتك الطبية.',
      startButton: 'ابدأ'
    },
    form: {
      previousConcussions: {
        title: 'تاريخ الارتجاجات',
        toggle: 'لقد تعرضت بالفعل لارتجاج واحد أو أكثر في المخ'
      },
      concussionDetails: {
        title: 'ارتجاج',
        date: 'التاريخ التقريبي (شهر/سنة)',
        circumstances: 'الظروف (مباراة، تدريب، أخرى)',
        symptoms: 'الأعراض الرئيسية التي شعرت بها',
        duration: 'مدة الأعراض (أيام)',
        medicalConsultation: 'لقد استشرت طبيبًا بخصوص هذا الارتجاج',
        treatment: 'العلاج أو المتابعة الطبية التي تلقيتها'
      },
      addConcussion: 'إضافة ارتجاج',
      additionalInfo: {
        title: 'معلومات إضافية',
        label: 'معلومات أخرى ذات صلة بتاريخك'
      },
      submitButton: 'إرسال'
    },
    confirmation: {
      title: 'تم إرسال الاستبيان',
      thankYou: 'شكرًا لإكمال الاستبيان حول تاريخ ارتجاجات المخ الخاصة بك.',
      recordedHistory: 'التاريخ المسجل: {count} ارتجاج(ات)',
      medicalTeamInfo: 'سيتم استخدام هذه المعلومات من قبل الفريق الطبي لتخصيص متابعتك.',
      backButton: 'عودة'
    }
  },
  concussionSymptoms: {
    logoAlt: 'شعار الاتحاد الفرنسي للرجبي',
    title: 'التقييم الذاتي للأعراض',
    instructions: {
      description1: 'هذا الاستبيان جزء من بروتوكول FFR الرسمي (مستوحى من SCAT5) ويجب إكماله يوميًا، حتى تعافيك الكامل.',
      description2: 'لكل عرض، يرجى الإشارة إلى:',
      presence: 'وجوده أو غيابه',
      severity: 'مستوى شدته (على مقياس من 0 إلى 6)',
      startButton: 'ابدأ'
    },
    form: {
      severityLegend: 'الشدة: 0 (لا يوجد) إلى 6 (شديد)',
      categories: {
        physical: 'أعراض جسدية',
        cognitive: 'أعراض معرفية',
        emotional: 'أعراض عاطفية',
        sleep: 'أعراض متعلقة بالنوم'
      },
      severity: 'الشدة',
      submitButton: 'إرسال'
    },
    confirmation: {
      title: 'تم إرسال الاستبيان',
      thankYou: 'شكرًا لإكمال استبيان التقييم الذاتي للأعراض.',
      backButton: 'عودة'
    }
  },
  progressiveReturnFollowUp: {
    logoAlt: 'شعار الاتحاد الفرنسي للرجبي',
    title: 'برنامج العودة إلى اللعب (RPDJ)',
    instructions: {
      description1: 'هذا الاستبيان جزء من بروتوكول FFR الرسمي للعودة التدريجية إلى اللعب بعد ارتجاج المخ.',
      description2: 'يجب عليك إكمال هذا الاستبيان بعد كل مرحلة من مراحل العودة للتحقق من غياب الأعراض قبل الانتقال إلى المرحلة التالية.',
      startButton: 'ابدأ'
    },
    form: {
      stageTitle: 'استبيان المرحلة {stage}',
      currentStage: {
        title: 'المرحلة الحالية',
        selectLabel: 'اختر مرحلتك الحالية'
      },
      plannedActivity: {
        title: 'النشاط المخطط له',
        label: 'صف النشاط الذي تم القيام به خلال هذه المرحلة'
      },
      activityCompletion: {
        title: 'إتمام النشاط',
        toggle: 'لقد أكملت النشاط المخطط له'
      },
      symptomsAppearance: {
        title: 'ظهور الأعراض',
        toggle: 'ظهرت أعراض أثناء أو بعد النشاط',
        warning: 'تنبيه: وجود أعراض يتطلب العودة إلى المرحلة السابقة. استشر طبيبك.',
        specifySymptoms: 'يرجى تحديد الأعراض التي ظهرت:'
      },
      severityLegend: 'الشدة: 0 (لا يوجد) إلى 6 (شديد)',
      categories: {
        physical: 'أعراض جسدية',
        cognitive: 'أعراض معرفية',
        emotional: 'أعراض عاطفية',
        sleep: 'أعراض متعلقة بالنوم'
      },
      comments: {
        title: 'تعليقات',
        label: 'تعليقات إضافية'
      },
      submitButton: 'إرسال'
    },
    confirmation: {
      title: 'تم إرسال الاستبيان',
      stageTitle: 'برنامج العودة إلى اللعب - المرحلة {stage}',
      thankYou: 'شكرًا لإكمال استبيان المتابعة للمرحلة {stage}.',
      symptomsWarning: 'تنبيه: ظهرت أعراض. يجب عليك العودة إلى المرحلة السابقة واستشارة طبيبك.',
      congratulations: 'تهانينا: لقد أكملت هذه المرحلة بدون أعراض. يمكنك الانتقال إلى المرحلة التالية بعد 24 ساعة.',
      activityNotCompleted: 'النشاط لم يكتمل: حاول إكمال النشاط قبل الانتقال إلى المرحلة التالية.',
      nextStage: 'المرحلة التالية: {description}',
      backButton: 'عودة'
    },
    stages: {
      options: {
        1: 'المرحلة 1: راحة تامة',
        2: 'المرحلة 2: نشاط خفيف',
        3: 'المرحلة 3: تمارين خاصة بالرجبي',
        4: 'المرحلة 4: تدريب بدون تلامس',
        5: 'المرحلة 5: تدريب مع تلامس',
        6: 'المرحلة 6: العودة إلى اللعب'
      },
      descriptions: {
        1: 'راحة جسدية ومعرفية تامة حتى اختفاء الأعراض.',
        2: 'أنشطة هوائية خفيفة مثل المشي أو ركوب الدراجة الثابتة بكثافة منخفضة.',
        3: 'تمارين خاصة بالرجبي دون خطر التعرض لصدمة في الرأس.',
        4: 'تمارين تدريبية أكثر تعقيدًا بدون تلامس.',
        5: 'بعد الحصول على تصريح طبي، استئناف أنشطة التدريب العادية مع التلامس.',
        6: 'العودة إلى اللعب الطبيعي بعد الحصول على تصريح طبي.'
      },
      stage7: 'المرحلة 7: العودة إلى اللعب - بعد الحصول على تصريح طبي.'
    }
  },
  symptoms: {
    // Physical symptoms
    headache: 'صداع',
    nausea: 'غثيان',
    vomiting: 'قيء',
    dizziness: 'دوار / شعور بالدوخة',
    visionProblems: 'اضطرابات بصرية (رؤية ضبابية، مزدوجة)',
    lightSensitivity: 'حساسية للضوء',
    noiseSensitivity: 'حساسية للصوت',
    balanceProblems: 'اضطرابات التوازن',
    fatigue: 'تعب جسدي',
    slowness: 'شعور بالتباطؤ',
    // Cognitive symptoms
    mentalConfusion: 'ارتباك / فقدان التوجه',
    memoryProblems: 'اضطرابات الذاكرة',
    concentrationDifficulties: 'صعوبات في التركيز',
    mentalSlowness: 'شعور بـ "البطء الذهني"',
    // Emotional symptoms
    irritability: 'سرعة الانفعال',
    sadness: 'حزن أو مزاج مكتئب',
    anxiety: 'قلق / عصبية',
    moodSwings: 'تقلبات مزاجية',
    // Sleep symptoms
    sleepProblems: 'صعوبات في النوم',
    excessiveSleepiness: 'نعاس مفرط',
    poorSleepQuality: 'استيقاظ متكرر / جودة نوم سيئة'
  },
  exercises: {
    sections: {
      videoExercises: 'تمارين الفيديو الخاصة بي',
      exercises: 'تماريني',
      breathing: 'تفسي',
      questionnaires: 'استبياناتي'
    },
    tests: {
      dsst: {
        name: 'اختبار DSST',
        description: 'سرعة المعالجة والانتباه المستمر',
        instructions: {
          title: 'تعليمات اختبار DSST',
          description1: 'يقيس هذا الاختبار سرعة المعالجة والانتباه المستمر لديك.',
          description2: 'سترى سلسلة من الأرقام، واحدًا تلو الآخر. لكل رقم، يجب عليك اختيار الرمز المقابل وفقًا للأسطورة المعروضة في أعلى الشاشة.',
          description3: 'حاول الإجابة بأسرع ما يمكن وبأكبر قدر ممكن من الدقة.',
          description4: 'مدة الاختبار {count} ثانية.',
          startButton: 'بدء الاختبار'
        },
        running: {
          timeRemaining: 'الوقت المتبقي:',
          question: 'السؤال:'
        },
        results: {
          title: 'نتائج اختبار DSST',
          score: 'النتيجة',
          accuracy: 'الدقة',
          averageResponseTime: 'متوسط وقت الاستجابة',
          correctAnswers: 'إجابات صحيحة',
          retryButton: 'إعادة الاختبار'
        }
      },
      srt: {
        name: 'اختبار SRT',
        description: 'تقييم وقت الاستجابة',
        instructions: {
          title: 'تعليمات اختبار SRT',
          description1: 'يقيس هذا الاختبار وقت الاستجابة البسيط لديك.',
          description2: 'سيظهر منبه بصري (شكل) على الشاشة. انقر بأسرع ما يمكن بمجرد رؤية المنبه.',
          description3: 'سيتم قياس وقت استجابتك بالمللي ثانية.',
          description4: 'يتضمن الاختبار {count} محاولات.',
          startButton: 'بدء الاختبار'
        },
        running: {
          trial: 'المحاولة: {current} / {total}',
          remaining: 'المتبقي: {count}',
          waiting: 'انتظر ظهور المنبه...',
          lastTime: 'الوقت الأخير: {time}'
        },
        results: {
          title: 'نتائج اختبار SRT',
          score: 'النتيجة (متوسط أفضل 10 نتائج)',
          avgReactionTime: 'متوسط وقت الاستجابة',
          fastestTime: 'أسرع وقت',
          validTrials: 'المحاولات الصالحة',
          retryButton: 'إعادة الاختبار'
        }
      },
      goNoGo: {
        name: 'اختبار Go/No-Go',
        description: 'التثبيط السلوكي والانتباه المستمر',
        instructions: {
          title: 'تعليمات اختبار Go/No-Go',
          description1: 'يقيس هذا الاختبار قدرتك على التثبيط السلوكي، وانتباهك المستمر، وسرعة المعالجة لديك.',
          description2: 'سيظهر نوعان من المنبهات على الشاشة:',
          goStimulus: 'منبه "Go" (دائرة خضراء): انقر بأسرع ما يمكن.',
          noGoStimulus: 'منبه "No-Go" (علامة X حمراء): لا تنقر، ثبط استجابتك.',
          description3: 'سيظهر كل منبه لمدة قصيرة. حاول أن تكون سريعًا ودقيقًا قدر الإمكان.',
          startButton: 'بدء الاختبار'
        },
        running: {
          trial: 'المحاولة: {current} / {total}',
          remaining: 'المتبقي: {count}',
          waiting: 'انتظر ظهور المنبه...',
          missedGo: 'فاتك! (Go)',
          correctNoGo: 'صحيح! (No-Go)',
          correctGo: 'صحيح! (Go) - {time}',
          incorrectNoGo: 'خطأ! (No-Go)'
        },
        results: {
          title: 'نتائج اختبار Go/No-Go',
          avgReactionTime: 'متوسط وقت الاستجابة (Go)',
          inhibitionRate: 'معدل التثبيط',
          commissionErrors: 'أخطاء العمولة (No-Go)',
          omissionErrors: 'أخطاء السهو (Go)',
          retryButton: 'إعادة الاختبار'
        }
      },
      stroop: {
        name: 'اختبار Stroop',
        description: 'التثبيط المعرفي والانتباه الانتقائي',
        instructions: {
          title: 'تعليمات اختبار Stroop',
          description1: 'يقيس هذا الاختبار قدرتك على التثبيط المعرفي والانتباه الانتقائي.',
          description2: 'سترى كلمات ألوان (مثل: "أحمر"، "أخضر") معروضة بألوان مختلفة.',
          description3: 'مهمتك هي اختيار اللون الذي كتبت به الكلمة، وليس ما تقوله الكلمة.',
          description4: 'على سبيل المثال، إذا رأيت كلمة "أحمر" مكتوبة باللون الأخضر، يجب عليك اختيار "أخضر".',
          description5: 'حاول الإجابة بأسرع ما يمكن وبأكبر قدر ممكن من الدقة.',
          startButton: 'بدء الاختبار'
        },
        colorVision: {
          title: 'اختبار رؤية الألوان',
          description: 'يرجى اختيار لوحة الألوان التي تناسبك بشكل أفضل:',
          palettes: {
            standard: {
              name: 'قياسي',
              description: 'للرؤية العادية'
            },
            protanopia: {
              name: 'بروتانوبيا',
              description: 'نقص رؤية اللون الأحمر'
            },
            tritanopia: {
              name: 'تريتانوبيا',
              description: 'نقص رؤية اللون الأزرق'
            },
            deuteranopia: {
              name: 'ديوتيرانوبيا',
              description: 'نقص رؤية اللون الأخضر'
            }
          }
        },
        verification: {
          title: 'التحقق من رؤية الألوان',
          question: 'ما هو اللون المعروض أدناه؟'
        },
        running: {
          trial: 'المحاولة:',
          remaining: 'المتبقي:',
          waitingMessage: 'انتظر ظهور الكلمة...'
        },
        feedback: {
          timeout: 'انتهى الوقت!',
          correct: 'صحيح!',
          incorrect: 'خطأ! اللون الصحيح كان'
        },
        results: {
          title: 'نتائج اختبار Stroop',
          congruentReactionTime: 'وقت الاستجابة (متوافق)',
          incongruentReactionTime: 'وقت الاستجابة (غير متوافق)',
          stroopEffect: 'تأثير Stroop',
          errorRate: 'معدل الخطأ',
          inhibitionRate: 'معدل التثبيط',
          retryButton: 'إعادة الاختبار'
        },
        colors: {
          rouge: 'أحمر',
          vert: 'أخضر',
          bleu: 'أزرق',
          jaune: 'أصفر',
          violet: 'بنفسجي',
          orange: 'برتقالي',
          rose: 'وردي'
        }
      },
      trailMaking: {
        name: 'Trail Making Test',
        description: 'المرونة المعرفية وسرعة المعالجة',
        instructions: {
          title: 'تعليمات Trail Making Test',
          description1: 'يقيس هذا الاختبار مرونتك المعرفية وسرعة المعالجة لديك.',
          partA: 'الجزء أ: صل من 1 إلى 25 بالترتيب.',
          partB: 'الجزء ب: صل بالتناوب بين الأرقام (1←2...) والحروف (A←B...): 1←A←2←B... حتى 13.',
          drawing: 'اضغط على النقطة الأولى وبدون رفع إصبعك، ارسم خطًا مستمرًا يمر عبر كل نقطة بالترتيب. سيتم عرض المسار.',
          startButton: 'بدء الاختبار'
        },
        running: {
          partTitle: 'Trail Making Test – الجزء'
        },
        partB: {
          completedA: 'لقد أكملت الجزء أ',
          description1: 'سيبدأ الجزء ب الآن.',
          description2: 'هذه المرة، سيتعين عليك التناوب بين الأرقام والحروف:',
          description3: '1 ← A ← 2 ← B ← ...',
          startButton: 'بدء الجزء ب'
        },
        results: {
          title: 'نتائج Trail Making Test',
          timeA: 'وقت التمرين أ',
          timeB: 'وقت التمرين ب',
          mistakesA: 'أخطاء الجزء أ',
          mistakesB: 'أخطاء الجزء ب',
          retryButton: 'إعادة الاختبار'
        }
      },
      nBack: {
        name: 'اختبار N-Back',
        description: 'تقييم ذاكرة العمل',
        instructions: {
          title: 'تعليمات اختبار N-Back',
          description1: 'يقيم هذا الاختبار ذاكرة العمل والتركيز لديك.',
          description2: 'سيتم اقتراح ثلاثة مستويات: 1-back-2، back و 3-back. في كل مستوى، سيتم تقديم سلسلة من الأرقام لك واحدًا تلو الآخر.',
          description3: 'مهمتك هي الإشارة إلى ما إذا كان الرقم الحالي مطابقًا للرقم المعروض قبل n من المواضع (تعتمد n على المستوى: 1، 2 أو 3).',
          description4: 'اضغط على "مطابق" إذا كنت تعتقد أن هذا هو الحال، وإلا اضغط على "مختلف".',
          description5: 'يتكون الاختبار من {count} أرقام لكل مستوى. حاول الإجابة بأسرع ما يمكن وبأكبر قدر ممكن من الدقة.',
          startLevel: 'مستوى البداية',
          level1: 'back-1',
          level2: 'back-2',
          level3: 'back-3',
          startButton: 'بدء الاختبار'
        },
        running: {
          level: 'المستوى {n}-Back',
          identical: 'مطابق',
          different: 'مختلف',
          memorize: 'تذكر ترتيب الأرقام التي تظهر على الشاشة',
          next: 'التالي'
        },
        results: {
          levelTitle: 'نتائج المستوى {n}-Back',
          precision: 'الدقة:',
          avgTime: 'متوسط الوقت:',
          nextLevel: 'الانتقال إلى {n}-Back',
          endTest: 'لإكمال الاختبار',
          finalTitle: 'نتائج اختبار N-Back',
          avgReactionTime: 'متوسط وقت الاستجابة',
          validTrials: 'المحاولات الصالحة',
          retryButton: 'إعادة الاختبار'
        }
      }
    },
    videoTests: {
      bess: {
        name: 'اختبار BESS',
        description: 'تقييم توازنك',
        instructions: {
          title: 'تعليمات اختبار التوازن (BESS)',
          description1: 'يسمح هذا الاختبار بقياس توازنك واستقرار وضعيتك.',
          description2: 'سيُطلب منك التوازن على قدم واحدة، واليدان على الوركين والعينان مغمضتان. سيقوم النظام بتحليل حركات جسمك باستخدام الكاميرا الأمامية.',
          rules: {
            eyesClosed: 'أبقِ عينيك مغمضتين طوال مدة الاختبار.',
            handsOnHips: 'حافظ على يديك على الوركين.',
            holdPosition: 'ابقَ ثابتًا وحافظ على الوضعية لمدة 20 ثانية دون فقدان التوازن.'
          },
          errors: 'يتم احتساب خطأ في كل مرة تفتح فيها عينيك، أو تحرك قدميك، أو ترفع يديك عن وركيك، أو تفقد توازنك.',
          automatic: 'الاختبار تلقائي. يبدأ بمجرد أن تتخذ الوضعية الصحيحة.',
          continueButton: 'متابعة'
        },
        steps: {
          title: 'كيفية إجراء الاختبار:',
          calibration: {
            title: '1. المعايرة',
            description: 'قف أمام الكاميرا لمعايرة النظام'
          },
          position: {
            title: '2. الوضعية المراد الحفاظ عليها',
            description: 'قف على قدم واحدة، واليدان على الوركين، والعينان مغمضتان'
          },
          startButton: 'بدء الاختبار'
        },
        setup: {
          phoneStable: 'ضع هاتفك على سطح مستقر',
          videoLoading: 'جاري تحميل الفيديو...'
        },
        calibration: {
          fullBody: 'ضع جسمك بالكامل داخل الإطار',
          waiting: 'ستبدأ المعايرة، لا تتحرك',
          inProgress: 'المعايرة جارية، لا تتحرك',
          oneFoot: 'قف على قدمك غير المهيمنة',
          handsOnHips: 'ضع يديك على الوركين',
          ready: 'سيبدأ الاختبار، لا تتحرك'
        },
        testing: {
          message: 'الاختبار جارٍ، أغمض عينيك'
        },
        results: {
          title: 'نتائج اختبار التوازن',
          oneFootErrors: 'الأخطاء على قدم واحدة',
          retryButton: 'إعادة الاختبار'
        }
      },
      eyeTracking: {
        name: 'Eye Tracking',
        description: 'تتبع حركات العين',
        instructions: {
          title: 'تعليمات اختبار Eye Tracking',
          description1: 'يسمح هذا الاختبار بقياس حركات عينيك، وانتباهك البصري، وقدرتك على تتبع منبه.',
          description2: 'ستتحرك نقطة بيضاء على الشاشة وفقًا لمسار محدد.',
          rule1: 'أبقِ رأسك ثابتًا في مواجهة الشاشة.',
          rule2: 'اتبع النقطة بعينيك فقط، دون تحريك رأسك.',
          rule3: 'ركز وحاول أن تظل منتبهًا طوال مدة التمرين.',
          description3: 'هذا الاختبار لا يتطلب أي تفاعل. يتم تلقائيًا لمدة ثوانٍ قليلة.',
          startButton: 'بدء الاختبار'
        },
        setup: {
          videoLoading: 'جاري تحميل الفيديو...',
          alignFace: 'قم بمحاذاة وجهك مع الخطوط'
        },
        results: {
          title: 'نتائج تتبع العين',
          concussionProbability: 'احتمالية الارتجاج',
          retryButton: 'إعادة الاختبار'
        }
      }
    },
    breatheExercise: {
      name: 'تمارين التنفس',
      description: 'التنفس والاسترخاء',
      instructions: {
        title: 'اختر بروتوكول تنفس',
        level: 'المستوى:',
        details: {
          recommendedContext: 'السياق الموصى به:',
          contraindications: 'موانع الاستعمال:',
          remarks: 'ملاحظات:',
          breathingPhases: 'مراحل التنفس:',
          inhale: 'شهيق',
          holdInhale: 'حبس النفس (امتلاء)',
          exhale: 'زفير',
          holdExhale: 'حبس النفس (فراغ)',
          seconds: 'ثوانٍ',
          recommendedCycles: 'الدورات الموصى بها:',
          cyclesPerMinute: '{n} أنفاس في الدقيقة لمدة {m} دقائق',
          selectButton: 'اختر هذا البروتوكول',
          changeButton: 'تغيير التمرين'
        }
      },
      running: {
        prepare: 'استعد',
        relax: 'استرخِ، التمرين سيبدأ قريبًا...',
        followRythm: 'اتبع الإيقاع الموضح على الشاشة وتغييرات الألوان لإرشادك.',
        cycle: 'الدورة:',
        timeRemaining: 'الوقت المتبقي:',
        inhale: 'استنشق',
        hold: 'احبس',
        exhale: 'ازفر',
        finishButton: 'إنهاء التمرين'
      },
      results: {
        title: 'انتهى تمرين التنفس',
        completionMessage: 'لقد أكملت {completed} دورات تنفس خلال مدة {duration}.',
        mainEffect: 'التأثير الرئيسي:',
        recommendedContext: 'السياق الموصى به:',
        feelings: 'كيف تشعر؟ خذ لحظة لملاحظة آثار هذا التمرين على جسدك وعقلك.',
        backButton: 'العودة إلى التمارين'
      },
      protocols: {
        coherence: {
          name: 'الاتساق القلبي',
          desc: 'مهدئ',
          effect: 'تهدئة عامة، تنظيم تقلب معدل ضربات القلب، تقليل التوتر',
          context: 'الاسترخاء، التعافي، الاستعداد الذهني، الاستخدام اليومي',
          remarks: 'يستخدم على نطاق واسع في الأوساط الطبية والرياضية والتأمل',
          level: 'مبتدئ',
          contraindications: 'لا يوجد'
        },
        pranayama: {
          name: 'براناياما لطيف',
          desc: 'مستوحى من اليوغا التقليدية',
          effect: 'توازن عاطفي، إعادة تركيز، إبطاء العقل',
          context: 'الانتقالات، ممارسات التأمل، التعافي الذهني',
          remarks: 'انتقال لطيف إلى ممارسات أكثر تعقيدًا',
          level: 'جميع المستويات',
          contraindications: 'تجنب إذا شعرت بضيق أو دوار'
        },
        respiration12: {
          name: 'تنفس 1:2',
          desc: 'تهدئة مطولة',
          effect: 'تنشيط الجهاز الباراسمبثاوي، إبطاء القلب والتنفس',
          context: 'العودة إلى الهدوء، التعافي بعد الجهد، التوتر الحاد',
          remarks: 'يُقترح كـ "تنفس مضاد للذعر" في التطبيق',
          level: 'مبتدئ',
          contraindications: 'لا يوجد'
        },
        respiration21: {
          name: 'تنفس 2:1',
          desc: 'تنشيط خفيف',
          effect: 'تنشيط معرفي وذهني خفيف، زيادة اليقظة',
          context: 'ما قبل المباراة، قبل التحدث، الإحماء الذهني',
          remarks: 'لا ينبغي الخلط بينه وبين تقنيات فرط التنفس',
          level: 'مبتدئ',
          contraindications: 'تجنب لمرضى الضغط المرتفع غير المتابعين'
        },
        box: {
          name: 'تنفس المربع (Box Breathing)',
          desc: 'تنفس مربع',
          effect: 'تعافي ذهني، إعادة تركيز، إدارة التوتر',
          context: 'الإدارة العاطفية، المقابلات المجهدة، رياضة المستوى العالي',
          remarks: 'تستخدمه القوات الخاصة وفي اليقظة الذهنية',
          level: 'متوسط',
          contraindications: 'تجنب في حالة الدوار أو اضطرابات الجهاز التنفسي الحادة'
        },
        fourSevenEight: {
          name: '4-7-8',
          desc: 'دكتور أندرو ويل',
          effect: 'حث النوم، استرخاء عميق',
          context: 'وقت النوم، قلق مرتفع، استرخاء عميق',
          remarks: 'يتم القيام به جالسًا أو مستلقيًا، وليس أثناء القيادة أبدًا',
          level: 'متقدم',
          contraindications: 'لا يُنصح به للأشخاص الذين يعانون من الربو، أو فرط التنفس، أو انخفاض ضغط الدم الشديد'
        }
      }
    }
  },
  s: 'ث',
  ms: 'مل ث',
  forms: {
    title: 'استبياناتي',
    questionnaire: 'استبيان',
    available: 'متاح',
    concussionHistory: {
      name: 'تاريخ الارتجاجات',
      description: 'تاريخك مع ارتجاجات المخ'
    },
    concussionSymptoms: {
      name: 'التقييم الذاتي للأعراض',
      description: 'استبيان يومي حول أعراضك'
    },
    progressiveReturnFollowUp: {
      name: 'متابعة العودة التدريجية',
      description: 'تقييم بعد كل مرحلة'
    }
  }
}
